import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
//import app from '../main'
//import Vue from 'vue'
//import Shop from "@/views/Shop";
const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    beforeEnter() {location.href = 'https://zarinmenu.ir'}
    //component: () => import('@/views/Home.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta:{requiresAuth: true}
  },  
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
  }, 
  {
    path: '/auth/register',
    name: 'Register',
    component: () => import('@/views/auth/Register.vue'),
  },
  {
    path: '/auth/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/auth/ForgotPassword.vue'),
  },
  {
    path: '/auth/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/auth/ResetPassword.vue'),
  },
  {
    path: '/auth/confirm-password',
    name: 'ConfirmPassword',
    component: () => import('@/views/auth/ConfirmPassword.vue'),
  },
  {
    path: '/auth/verify-email',
    name: 'VerifyEmail',
    component: () => import('@/views/auth/VerifyEmail.vue'),
  },  
  {
      path: '/shop',
      name: 'Shop',
      component: () => import('@/views/Shop.vue'),
      meta: {requiresAuth: true}
  },
  //
  {
    path: '/shopList',
    name: 'ShopList',
    component: () => import('@/views/ShopList.vue'),
    meta: {requiresAuth: true}
},
  //
  {
      path: '/MenuList',//'/menulist',
      name: 'MenuList',
      component: () => import('@/views/MenuList.vue'),
      meta: {requiresAuth: true}
  },
  //
  {
    path: '/AnnouncementList',
    name: 'AnnouncementList',
    component: () => import('@/views/AnnouncementList.vue'),
    meta: {requiresAuth: true}
},
  //
  {
    path: '/announcement/edit/:id',
    name: 'EditAnnouncement',
    component: () => import('@/views/AddAnnouncement.vue'),
    meta: {requiresAuth: true}
},
{
  path: '/announcement/add',
  name: 'AddAnnouncement',
  component: () => import('../views/AddAnnouncement.vue'),
  meta: {requiresAuth: true}
},
  //
  {
      path: '/menu/add',
      name: 'AddMenu',
      component: () => import('../views/AddMenu.vue'),
      meta: {requiresAuth: true}
  },
  {
      path: '/menu/edit/:id',
      name: 'EditMenu',
      component: () => import('@/views/AddMenu.vue'),
      meta: {requiresAuth: true}
  },
  {
      path: '/menu/:id',
      name: 'Category',
      component: () => import('@/views/Category.vue'),
      meta: {requiresAuth: true}
  },
  {
      path: '/menu/:id/Add',
      name: 'AddCategory',
      component: () => import('@/views/AddCategory.vue'),
      meta: {requiresAuth: true }
  },
 {
      path: '/menu/:id/edit/:catid',
      name: 'EditCategory',
      component: () => import('@/views/AddCategory.vue'),
      meta: {requiresAuth: true}
  },
  {
      path: '/cat/:id',
      name: 'MenuItemList',
      component: () => import('@/views/MenuItemList.vue'),
      meta: {requiresAuth: true}
  },
  {
    path: '/cat/:id/Add',
    name: 'AddMenuItem',
    component: () => import('@/views/AddMenuItem.vue'),
    meta: {requiresAuth: true}
  },
  {
      path: '/cat/:id/edit/:menuitemid',
      name: 'EditMenuItem',
      component: () => import('@/views/AddMenuItem.vue'),
      meta: {requiresAuth: true}
  },
  {
     path: '/about',
     name: 'About',
     component: () => import('@/views/About.vue')
  },
  {
      path: '/:pathMatch(.*)*',
      name: 'Error',
      component: () => import('@/views/Error.vue')
  },
  {
    path: '/HomePage',
    name: 'HomePage',
    component: () => import('@/views/HomePage.vue'),
    //meta: {requiresAuth: false}
},
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  //document.querySelector(".flex-sidebar").classList.add("hidden");
  if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!store.getters.isLoggedIn) {
          next({
              path: '/login',
              query: to.query
          })
      }
      //console.log(store.getters.isShopRegister)
      if (!store.getters.isShopRegister && to.path!='/shop') {
        //console.log(to.path)
        next({
            path: '/shop',
            query: to.query
        })
      }  else {
          next()
      }
  } else {
      next() // make sure to always call next()!
  }
})
export default router
